export default __webpack_public_path__ + "static/media/staff-training.37e7554a.svg";